// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

// Utils
import { getElementId } from '../../../../../../common/elements/utils/elementPropertyUtils';

// Actions
import { startEditingMainEditor } from '../../../../../element/selection/selectionActions';

// Components
import ToolbarTool from '../../ToolbarTool';
import Icon from '../../../../../components/icons/Icon';

const RenameTool = (props) => {
    const { selectedElements, ...rest } = props;
    const dispatch = useDispatch();

    const handleClick = (event) => {
        event.preventDefault();
        const element = selectedElements?.first();
        if (!element) return;
        dispatch(startEditingMainEditor(getElementId(element)));
    };

    return (
        <ToolbarTool {...rest} onClick={handleClick} isActive={false}>
            <Icon name="toolbar-rename" />
        </ToolbarTool>
    );
};

RenameTool.propTypes = {
    selectedElements: PropTypes.object,
    name: PropTypes.string,
};

export default RenameTool;
